import { createContext, useContext } from 'react';
import { matchPath } from 'react-router-dom';

import { PagePaths } from '@/routes/page-paths';

export const isDealsListingPath = (pathname: string) =>
  matchPath(PagePaths.deals, pathname) !== null;

export const getDealsReturnUrl = (state: unknown) => {
  const returnTo = (state as { returnTo?: unknown } | null | undefined)?.returnTo;
  if (typeof returnTo !== 'string') return null;
  const url = new URL(returnTo, window.location.origin);
  return url.origin === window.location.origin && isDealsListingPath(url.pathname) ? url : null;
};

export const DealsBackgroundContext = createContext(false);

export const useIsDealsBackground = () => useContext(DealsBackgroundContext);
